// Simple global event bus to notify UI about learning progress changes across screens (web/native)
const listeners = new Set()
let progressVersion = 0

export function subscribeProgressUpdate(cb) {
  if (typeof cb !== 'function') return () => {}
  listeners.add(cb)
  return () => {
    try { listeners.delete(cb) } catch {}
  }
}

export function emitProgressUpdate(payload) {
  // Increment a global monotonically increasing version so late subscribers can detect missed events
  progressVersion += 1
  listeners.forEach((cb) => {
    try { cb(progressVersion, payload) } catch {}
  })
}

export function getProgressVersion() {
  return progressVersion
}
